import React, { useState, useEffect, Component } from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import TableView from '../../TableView';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const ExportBLSecondDT = ({ bLNumber, data, onhadleMarksNumbers, onhadlePackageDesc, onhadleFreightChargers, onhadleRevenueTons, onhadleRate, onhadlePer, onhadleCollect,
    onhadlePrepaid, onhadleExchageRate, onhadlePrepaidAt, onhadlePaybleAt, onhadleTotPaidNatCurrency, onhadlePlaceDateIssue, onhadleNoOfOrgBls }) => {
    // const [baseUrl, setBaseUrl] = useState('http://127.0.0.1:8000/api/');
    const [baseUrl, setBaseUrl] = useState('http://mol.evolve-demo.com/api/');
    const [pageComponent, setPageComponent] = useState('airexportbl');

    const [firstFlightDateTextBoxes, setFirstFlightDateTextBoxes] = useState(1);
    const [firstFlightDate, setFirstFlightDate] = useState(['']);
    const [flightDateList, setFlightDateList] = useState([])

    const [marksNumbers, setMarksNumbers] = useState('');
    const [nowMarksNumbers, setNowMarksNumbers] = useState('');
    const [marksNumbersOn, setMarksNumbersOn] = useState(false);

    const [packageDesc, setPackageDesc] = useState('');
    const [nowPackageDesc, setNowPackageDesc] = useState('');
    const [packageDescOn, setPackageDescOn] = useState(false);

    const [freightChargers, setFreightChargers] = useState('');
    const [nowFreightChargers, setNowFreightChargers] = useState('');
    const [freightChargersOn, setFreightChargersOn] = useState(false);

    const [revenueTons, setRevenueTons] = useState('');
    const [nowRevenueTons, setNowRevenueTons] = useState('');
    const [revenueTonsOn, setRevenueTonsOn] = useState(false);

    const [rate, setRate] = useState('');
    const [nowrate, setNowRate] = useState('');
    const [rateOn, setRateOn] = useState(false);

    const [per, setPer] = useState('');
    const [nowper, setNowPer] = useState('');
    const [perOn, setPerOn] = useState(false);

    const [prepaid, setPrepaid] = useState(undefined);
    const [nowPrepaid, setNowPrepaid] = useState('');
    const [prepaidOn, setPrepaidOn] = useState(false)

    const [collect, setCollect] = useState('');
    const [nowcollect, setNowCollect] = useState('');
    const [collectOn, setCollectOn] = useState(false);

    const [exchageRate, setExchageRate] = useState('');
    const [nowExchageRate, setNowExchageRate] = useState('');
    const [exchageRateOn, setExchageRateOn] = useState(false);

    const [prepaidAt, setPrepaidAt] = useState('');
    const [nowPrepaidAt, setNowPrepaidAt] = useState('');
    const [prepaidAtOn, setPrepaidAtOn] = useState(false);

    const [paybleAt, setPaybleAt] = useState('');
    const [nowPaybleAt, setNowPaybleAt] = useState('');
    const [paybleAtOn, setPaybleAtOn] = useState(false);

    const [totPaidNatCurrency, setTotPaidNatCurrency] = useState('');
    const [nowtotPaidNatCurrency, setNowTotPaidNatCurrency] = useState('');
    const [totPaidNatCurrencyOn, setTotPaidNatCurrencyOn] = useState(false);

    const [placeDateIssue, setplaceDateIssue] = useState('');
    const [nowplaceDateIssue, setNowplaceDateIssue] = useState('');
    const [placeDateIssueOn, setplaceDateIssueOn] = useState(false);

    const [noOfOrgBls, setNoOfOrgBls] = useState('');
    const [nowNoOfOrgBls, setNowNoOfOrgBls] = useState('');
    const [noOfOrgBlsOn, setnoOfOrgBlsOn] = useState(false);



    const setperpaidVal = (e) => {
        setPrepaidOn(true)
        setNowPrepaid(e)
    }
    const setMaskNo = (e) => {
        setMarksNumbersOn(true)
        setNowMarksNumbers(e)
    }
    const pkgDesc = (e) => {
        setPackageDescOn(true)
        setNowPackageDesc(e)
    }
    const freightChargersVal = (e) => {
        setFreightChargersOn(true)
        setNowFreightChargers(e)
    }
    const revenueTonsVal = (e) => {
        setRevenueTonsOn(true)
        setNowRevenueTons(e)
    }
    const rateVal = (e) => {
        setRateOn(true)
        setNowRate(e)
    }
    const perVal = (e) => {
        setPerOn(true)
        setNowPer(e)
    }
    const collectVal = (e) => {
        setCollectOn(true)
        setNowCollect(e)
    }
    const exchageRateVal = (e) => {
        setExchageRateOn(true)
        setNowExchageRate(e)
    }
    const prepaidAtVal = (e) => {
        setPrepaidAtOn(true)
        setNowPrepaidAt(e)
    }
    const paybleAtVal = (e) => {
        setPaybleAtOn(true)
        setNowPaybleAt(e)
    }
    const totPaidNatCurrencyVal = (e) => {
        setTotPaidNatCurrencyOn(true)
        setNowTotPaidNatCurrency(e)
    }
    const placeDateIssueVal = (e) => {
        setplaceDateIssueOn(true)
        setNowplaceDateIssue(e)
    }
    const noOfOrgBlsVal = (e) => {
        setnoOfOrgBlsOn(true)
        setNowNoOfOrgBls(e)
    }

    useEffect(() => {
        if (data !== undefined) {
            setMarksNumbers(data.MarksNumbers)
            setPackageDesc(data.PackageDesc)
            setFreightChargers(data.FreightChargers)
            setRevenueTons(data.RevenueTons)
            setRate(data.Rate)
            setPer(data.Per)
            setPrepaid(data.Prepaid)
            setCollect(data.Collect)
            setExchageRate(data.ExchageRate)
            setPrepaidAt(data.PrepaidAt)
            setPaybleAt(data.PaybleAt)
            setTotPaidNatCurrency(data.TotPaidNatCurrency)
            setplaceDateIssue(data.PlaceDateIssue)
            setNoOfOrgBls(data.NoOfOrgBls)
        }

    })

    fetch(`${baseUrl}${pageComponent}/show/${bLNumber}`)
        .then(response => response.json())
        .then(data => {



        }, [])
        .catch(error => {
            console.error(error)
        });


        const flightFirstDateSet = (index, value) => {
    
            const newInputValues = [...firstFlightDate];
            newInputValues[index] = value;
            setFirstFlightDate(newInputValues);
            if(newInputValues[index].length !== 0){
                addNewTextBox(index)
            }
            
         
            
        }
    
        
        const addNewTextBox = () => {
    
            console.log();
    
            if (firstFlightDate[firstFlightDate.lengthn - 0] !== '') {
                setFirstFlightDateTextBoxes(firstFlightDateTextBoxes + 1);
                setFirstFlightDate([...firstFlightDate, '']);
            }
    
            
        };



    onhadleMarksNumbers(nowMarksNumbers !== '' ? nowMarksNumbers : marksNumbers);
    onhadlePackageDesc(nowPackageDesc !== '' ? nowPackageDesc : packageDesc);
    onhadleFreightChargers(nowFreightChargers !== '' ? nowFreightChargers : freightChargers);
    onhadleRate(nowrate !== '' ? nowrate : rate);
    onhadlePer(nowper !== '' ? nowper : per);
    onhadleRevenueTons(nowRevenueTons !== '' ? nowRevenueTons : revenueTons);
    onhadlePrepaidAt(nowPrepaidAt !== '' ? nowPrepaidAt : prepaidAt);
    onhadleCollect(nowcollect !== '' ? nowcollect : collect);
    onhadleExchageRate(nowExchageRate !== '' ? nowExchageRate : exchageRate);
    onhadlePrepaid(nowPrepaid !== '' ? nowPrepaid : prepaid);
    onhadlePaybleAt(nowPaybleAt !== '' ? nowPaybleAt : paybleAt);
    onhadleTotPaidNatCurrency(nowtotPaidNatCurrency !== '' ? nowtotPaidNatCurrency : totPaidNatCurrency);
    onhadlePlaceDateIssue(nowplaceDateIssue !== '' ? nowplaceDateIssue : placeDateIssue);
    onhadleNoOfOrgBls(nowNoOfOrgBls !== '' ? nowNoOfOrgBls : noOfOrgBls);





    return (
        <Container>
            <ToastContainer autoClose={2000} />
            <Row>
                <Col>
                    <Form className='mt-4 bottom-border pb-3'>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>No OF Pieces RCP</Form.Label>
                                    <Form.Control type="text" autoComplete="off" placeholder="" value={nowMarksNumbers ? nowMarksNumbers : marksNumbersOn == false ? marksNumbers : ''} onChange={e => setMaskNo(e.target.value)} name="" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Gross Weight</Form.Label>
                                    <Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>KG \ LB</Form.Label>
                                    <Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Commodity Item No</Form.Label>
                                    <Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Chargeble Weight</Form.Label>
                                    <Form.Control type="text" autoComplete="off" placeholder="" value={nowMarksNumbers ? nowMarksNumbers : marksNumbersOn == false ? marksNumbers : ''} onChange={e => setMaskNo(e.target.value)} name="" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Rate / Charge</Form.Label>
                                    <Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Total</Form.Label>
                                    <Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" />
                                </Form.Group>
                            </Col>

                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nature and Quantity Of Goods</Form.Label>
                                    <Form.Control as="textarea" value={nowFreightChargers ? nowFreightChargers : freightChargersOn == false ? freightChargers : ''} onChange={e => freightChargersVal(e.target.value)} placeholder="" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Marks & Numbers</Form.Label>
                                    <Form.Control as="textarea" value={nowFreightChargers ? nowFreightChargers : freightChargersOn == false ? freightChargers : ''} onChange={e => freightChargersVal(e.target.value)} placeholder="" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>INCL. Dimensions Or Volume</Form.Label>
                                    <Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" />
                                </Form.Group>
                            </Col>

                        </Row>
                        <Row>
                            <Col></Col>
                            <Col> <Form.Label>Prepaid</Form.Label></Col>
                            <Col> <Form.Label>Collect</Form.Label></Col>
                            <Col>
                                {firstFlightDate.map((value, index) => (
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Flight/Dates 1</Form.Label>
                                                <Form.Control type="text" key={index} placeholder="" autoComplete="off" onBlur={(e) => flightFirstDateSet(index, e.target.value)} />
                                            </Form.Group>

                                        </Col>
                                    </Row>
                                ))}

                            </Col>
                        </Row>
                        <Row>
                            <Col><Form.Label>Weight Charge</Form.Label></Col>
                            <Col> <Form.Label><Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" /></Form.Label></Col>
                            <Col> <Form.Label><Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" /></Form.Label></Col>
                            <Col></Col>
                        </Row>
                        <Row>
                            <Col><Form.Label>Valuation Charge</Form.Label></Col>
                            <Col> <Form.Label><Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" /></Form.Label></Col>
                            <Col> <Form.Label><Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" /></Form.Label></Col>
                            <Col></Col>
                        </Row>
                        <Row>
                            <Col><Form.Label>Total Other Charge Due Carrier</Form.Label></Col>
                            <Col> <Form.Label><Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" /></Form.Label></Col>
                            <Col> <Form.Label><Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" /></Form.Label></Col>
                            <Col></Col>
                        </Row>
                        <Row>
                            <Col><Form.Label>Total Other Charge Due Agent</Form.Label></Col>
                            <Col> <Form.Label><Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" /></Form.Label></Col>
                            <Col> <Form.Label><Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" /></Form.Label></Col>
                            <Col></Col>
                        </Row>
                        <Row>
                            <Col><Form.Label>Total Paid</Form.Label></Col>
                            <Col> <Form.Label><Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" /></Form.Label></Col>
                            <Col> <Form.Label><Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" /></Form.Label></Col>
                            <Col></Col>
                        </Row>
                        <Row>
                            <Col><Form.Label>Currency Conversion Rate</Form.Label></Col>
                            <Col> <Form.Label><Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" /></Form.Label></Col>
                            <Col> <Form.Label><Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" /></Form.Label></Col>
                            <Col></Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="MasterBL">
                                    <Form.Label>Total Collect</Form.Label>
                                    <Form.Control type="text" value={nowExchageRate ? nowExchageRate : exchageRateOn == false ? exchageRate : ''} onChange={e => exchageRateVal(e.target.value)} autoComplete="off" placeholder="" name="BlNo" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>CC Charge in Dest</Form.Label>
                                    <Form.Control type="text" value={nowPrepaidAt ? nowPrepaidAt : prepaidAtOn == false ? prepaidAt : ''} onChange={e => prepaidAtVal(e.target.value)} placeholder="" autoComplete="off" name="Hbl" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Charges In Destination</Form.Label>
                                    <Form.Control type="text" value={nowPaybleAt ? nowPaybleAt : paybleAtOn == false ? paybleAt : ''} onChange={e => paybleAtVal(e.target.value)} placeholder="" autoComplete="off" name="date" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Row>
                                        <Col> <Form.Label>Executed On</Form.Label></Col>
                                        <Col> <Form.Label>Date</Form.Label></Col>
                                    </Row>
                                    <Form.Control type="text" value={nowtotPaidNatCurrency ? nowtotPaidNatCurrency : totPaidNatCurrencyOn == false ? totPaidNatCurrency : ''} onChange={e => totPaidNatCurrencyVal(e.target.value)} autoComplete="off" placeholder="" name="Vessel" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Place</Form.Label>
                                    <Form.Control type="text" value={nowplaceDateIssue ? nowplaceDateIssue : placeDateIssueOn == false ? placeDateIssue : ''} onChange={e => placeDateIssueVal(e.target.value)} placeholder="" autoComplete="off" name="Voyage" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Total Collect Charger</Form.Label>
                                    <Form.Control type="text" placeholder="" value={nowNoOfOrgBls ? nowNoOfOrgBls : noOfOrgBlsOn == false ? noOfOrgBls : ''} onChange={e => noOfOrgBlsVal(e.target.value)} autoComplete="off" name="Voyage" />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Container>

    );

}

export default ExportBLSecondDT;